import React from 'react';
import { Button } from 'antd';
import ConditionalRender from '../../../../../shared/components/ConditionalRender';

interface TableFooterProps {
  isQueryTool?: boolean;
  onEditQuery?: () => void;
  onResetQuery?: () => void;
  onSaveAndClose: () => void;
  isSaving?: boolean;
  canEdit?: boolean;
}

const TableFooter: React.FC<TableFooterProps> = ({ isQueryTool, onEditQuery, onResetQuery, onSaveAndClose, isSaving, canEdit = true }) => {
  return (
    <div className="footerContainer">
      {isQueryTool ? (
        <div className="query-actions">
          <Button onClick={onEditQuery}>Edit Query</Button>
          <Button onClick={onResetQuery}>Reset Query</Button>
        </div>
      ) : (
        <ConditionalRender visible={canEdit}>
          <Button type="primary" onClick={onSaveAndClose} className="saveButton" loading={isSaving} disabled={isSaving}>
            Save
          </Button>
        </ConditionalRender>
      )}
    </div>
  );
};

export default TableFooter;
